import VisitorCounter from '@/components/feature/VisitorCounter';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          poster="https://readdy.ai/api/search-image?query=professional%20home%20renovation%20and%20construction%20site%20inside%20a%20bright%20modern%20Swiss%20residential%20house%2C%20skilled%20workers%20installing%20new%20wooden%20flooring%20and%20refurbishing%20interior%20walls%20with%20exposed%20warm%20brick%2C%20scaffolding%20and%20professional%20renovation%20tools%20neatly%20organized%2C%20warm%20natural%20sunlight%20streaming%20through%20large%20windows%2C%20earth%20tones%20and%20natural%20materials%2C%20clean%20organized%20workspace%2C%20high-end%20residential%20remodeling%20project%2C%20professional%20architectural%20photography%20with%20sharp%20details%20and%20simple%20neutral%20warm%20background%20highlighting%20craftsmanship%20and%20quality%20work&width=1920&height=1080&seq=renovation-construction-hero-2026&orientation=landscape"
          className="w-full h-full object-cover object-top"
        >
          <source src="https://videos.pexels.com/video-files/3252119/3252119-hd_1920_1080_30fps.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>
      <div className="relative z-10 w-full mx-auto max-w-7xl px-6 lg:px-8 py-36 text-center">
        <h1 className="text-5xl font-black tracking-tight text-white sm:text-7xl mb-4" dir="ltr">
          CasaReNovaPlus
        </h1>
        <p className="mt-4 text-xl font-semibold text-brand-300 mb-4">
          Votre partenaire rénovation à Neuenegg & Suisse romande
        </p>
        <p className="text-lg leading-8 text-white/80 max-w-3xl mx-auto"></p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="#contact"
            className="rounded-lg bg-brand-500 px-8 py-4 text-base font-semibold text-white hover:bg-brand-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Demander un devis gratuit
          </a>
          <a
            href="#services"
            className="rounded-lg bg-white/10 backdrop-blur-sm px-8 py-4 text-base font-semibold text-white border border-white/30 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            Voir nos services
          </a>
        </div>

        {/* Visitor counter */}
        <div className="mt-6 flex justify-center">
          <VisitorCounter />
        </div>

        {/* Stats / badges */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          <div className="bg-black/30 backdrop-blur-md rounded-xl p-5 border border-white/10">
            <div className="w-12 h-12 flex items-center justify-center bg-brand-500 rounded-lg mx-auto mb-3">
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base font-semibold text-white mb-1">Urgence 24/7</h3>
            <p className="text-gray-300 text-xs">Intervention rapide dans tout le canton</p>
          </div>
          <div className="bg-black/30 backdrop-blur-md rounded-xl p-5 border border-white/10">
            <div className="w-12 h-12 flex items-center justify-center bg-brand-500 rounded-lg mx-auto mb-3">
              <i className="ri-stack-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base font-semibold text-white mb-1">7 Prestations</h3>
            <p className="text-gray-300 text-xs">Multi-services pour tous vos besoins</p>
          </div>
          <div className="bg-black/30 backdrop-blur-md rounded-xl p-5 border border-white/10">
            <div className="w-12 h-12 flex items-center justify-center bg-brand-500 rounded-lg mx-auto mb-3">
              <i className="ri-leaf-line text-2xl text-white"></i>
            </div>
            <h3 className="text-base font-semibold text-white mb-1">Éco-responsable</h3>
            <p className="text-gray-300 text-xs">Solutions durables et produits écologiques</p>
          </div>
        </div>
      </div>
    </section>
  );
}
